<template>
  <v-container fluid>
    <PageHeader
      title="Users"
      icon="mdi-shield-account"
    >
      <template #actions>
        <v-btn
          v-if="hasScope('user:write')"
          color="primary"
          class="mr-2"
          @click="roleManagerOpen = true"
        >
          Manage Roles
        </v-btn>
        <v-btn
          v-if="hasScope('user:write')"
          color="primary"
          @click="addItem"
        >
          Add User
        </v-btn>
      </template>
    </PageHeader>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-text-field
          v-model="query"
          prepend-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
          density="compact"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet
          elevation="2"
          class="pa-md-2"
        >
          <v-data-table-server
            class="user-data-table"
            :headers="headers"
            :items="items"
            :loading="loading"
            v-model:options="options"
            :items-length="total"
          >
            <template #[`item.actions`]="{ item }">
              <template v-if="hasScope('user:write')">
                <v-tooltip location="bottom">
                  <template #activator="{ props }">
                    <v-icon
                      size="small"
                      class="mr-2"
                      v-bind="props"
                      :disabled="userDialog"
                      @click="editItem(item)"
                      v-on="props"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <v-tooltip location="bottom">
                  <template #activator="{ props }">
                    <v-icon
                      size="small"
                      v-bind="props"
                      :disabled="deleteDialog"
                      @click="deleteItem(item)"
                      v-on="props"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Delete User</span>
                </v-tooltip>
              </template>
            </template>
          </v-data-table-server>
        </v-sheet>
      </v-col>
    </v-row>
    <user-details />
    <role-manager v-model="roleManagerOpen" />
    <delete
      :id="selectedItem.id"
      :name="selectedItem.name"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/PageHeader";
import { debounce } from "lodash";
import UserDetails from "@/components/user/Details.vue";
import Delete from "@/components/Delete.vue";
import RoleManager from "@/components/RoleManager.vue";

export default {
  components: {
    PageHeader,
    UserDetails,
    Delete,
    RoleManager,
  },
  data() {
    return {
      query: "",
      options: {},
      selectedItem: {},
      roleManagerOpen: false,
      headers: [
        { title: "First Name", sortable: true, key: "firstName" },
        { title: "Last name", sortable: true, key: "lastName" },
        { title: "Email", sortable: true, key: "email" },
        { title: "Role", sortable: true, key: "roleName" },
        {
          title: "Actions",
          sortable: false,
          key: "actions",
          align: "center",
          width: "10%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      loading: "users/loading",
      items: "users/items",
      searchOptions: "users/searchOptions",
      searchQuery: "users/searchQuery",
      total: "users/total",
      userDialog: "user/details/dialog",
      deleteDialog: "delete/dialog",
      hasScope: "auth/hasScope",
    }),
  },
  watch: {
    query() {
      this.debouncedSearch();
      this.options.page = 1;
    },
    options() {
      this.executeSearch();
    },
  },
  mounted() {},
  created() {
    this.options = this.searchOptions;
    this.query = this.searchQuery;
    this.debouncedSearch = debounce(this.executeSearch, 250);
    this.loadRoles();
  },
  methods: {
    ...mapActions({
      search: "users/search",
      open: "user/details/open",
      loadRoles: "users/loadRoles",
      openDelete: "delete/open",
    }),
    executeSearch() {
      this.search({
        ...this.options,
        query: this.query,
      });
    },
    addItem() {
      this.open(undefined);
    },
    editItem(item) {
      this.open(item);
    },

    deleteItem(item) {
      this.selectedItem = item;
      this.openDelete();
    },
  },
};
</script>

<style scoped>
.center-vertically {
  align-items: center;
  display: flex;
}


:deep(.v-list__tile) {
  height: 1rem;
}

</style>
